import { default_header, default_header_example } from '../defaultData';

const getV12APIs = (userInfo) => {
  return [
    {
      title: 'SKU상품 리스트 조회',
      url: '/doc/SKU상품 리스트 조회',
      data: [
        {
          version: 'v1.2',
          url: '/stock/list/v1.2',
          method: 'POST',
          desc: (
            <ul className='style'>
              <li>SKU상품 리스트를 조회합니다.</li>
              <li>기본 날짜 검색일은 90일 입니다.</li>
            </ul>
          ),
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'start',
              required: '',
              type: 'Number',
              desc: (
                <div>
                  조회할 시작 카운트
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>0</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'limit',
              required: '',
              type: 'Number',
              desc: (
                <div>
                  조회할 갯수
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>100</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'search_key',
              required: '',
              type: 'String',
              desc: (
                <div>
                  검색 키
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>all</code>
                          </strong>
                        </td>
                        <td>
                          <strong>전체검색</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>sku_cd</code>
                          </strong>
                        </td>
                        <td>
                          <strong>SKU코드</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>stock_cd</code>
                          </strong>
                        </td>
                        <td>
                          <strong>재고관리코드</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>prod_name</code>
                          </strong>
                        </td>
                        <td>
                          <strong>SKU상품명</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'search_word',
              required: '',
              type: 'String[]',
              desc: '검색어',
            },
            {
              title: 'search_type',
              required: '',
              type: 'String',
              desc: (
                <div>
                  검색타입
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>partial</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>exact</code>
                          </strong>
                        </td>
                        <td>
                          <strong>완전일치</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>partial</code>
                          </strong>
                        </td>
                        <td>
                          <strong>부분일치</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'date_type',
              required: '',
              type: 'String',
              desc: (
                <div>
                  날짜검색대상
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>wdate</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                        <th>Description</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>wdate</code>
                          </strong>
                        </td>
                        <td>
                          <strong>등록일</strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>mdate</code>
                          </strong>
                        </td>
                        <td>
                          <strong>수정일</strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'sdate',
              required: '',
              type: 'String',
              desc: (
                <div>
                  검색시작일
                  <div className='description'>
                    ( YYYY-MM-DD | YYYY-MM-DD HH:MM:SS )<br />
                    미입력시 기본 90일로 조회됩니다.
                  </div>
                </div>
              ),
            },
            {
              title: 'edate',
              required: '',
              type: 'String',
              desc: (
                <div>
                  검색종료일
                  <div className='description'>
                    ( YYYY-MM-DD | YYYY-MM-DD HH:MM:SS )
                  </div>
                </div>
              ),
            },
            ...(userInfo.sol_no === 104083 ? [{
              title: 'sub_sol_no_list',
              required: '',
              type: 'Number[]',
              desc: (
                <div>
                  하위계정 sol_no 리스트
                  <div className='description'>
                    (값이 없는 경우 하위계정 전체 조회)
                  </div>
                </div>
              ),
            }] : []),
          ],
          body_example: {
            start: 0,
            limit: 100,
            search_key: 'all',
            search_word: ['456'],
            search_type: 'partial',
            date_type: 'wdate',
            sdate: '2020-12-25',
            edate: '2021-01-25',
          },
          response: [
            {
              title: 'results',
              required: 'O',
              type: 'Array',
              desc: '결과',
            },
            {
              title: 'sol_no',
              required: 'O',
              type: 'Number(8)',
              desc: '솔루션번호',
              indent: 1,
            },
            {
              title: 'ori_prod_no',
              required: 'O',
              type: 'Number(10)',
              desc: (
                <div>
                  원본 SKU상품 고유번호
                  <div className='description'>
                    (조회하는 SKU상품이 사본인경우 해당)
                  </div>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'prod_no',
              required: 'O',
              type: 'Number(10)',
              desc: 'SKU상품고유번호',
              indent: 1,
            },
            {
              title: 'sku_cd',
              required: 'O',
              type: 'String(40)',
              desc: 'SKU코드',
              indent: 1,
            },
            {
              title: 'stock_cd',
              required: 'O',
              type: 'String(100)',
              desc: '재고관리코드',
              indent: 1,
            },
            {
              title: 'prod_name',
              required: 'O',
              type: 'String(200)',
              desc: 'SKU상품명',
              indent: 1,
            },
            {
              title: 'main_depot_no',
              required: 'O',
              type: 'Number(10)',
              desc: 'SKU상품의 대표배송처 번호',
              indent: 1,
            },
            {
              title: 'made_date',
              required: 'O',
              type: 'String(10)',
              desc: '제조일자',
              indent: 1,
            },
            {
              title: 'expire_date',
              required: 'O',
              type: 'String(10)',
              desc: '유효일자',
              indent: 1,
            },
            {
              title: 'prod_width',
              required: 'O',
              type: 'Number(8)',
              desc: (
                <div>
                  상품규격(가로)
                  <div className='description'>(data type: Decimal(8,3))</div>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>0</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'prod_height',
              required: 'O',
              type: 'Number(8)',
              desc: (
                <div>
                  상품규격(세로)
                  <div className='description'>(data type: Decimal(8,3))</div>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>0</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'prod_depth',
              required: 'O',
              type: 'Number(8)',
              desc: (
                <div>
                  상품규격(높이)
                  <div className='description'>(data type: Decimal(8,3))</div>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>0</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'prod_weight',
              required: 'O',
              type: 'Number(8)',
              desc: (
                <div>
                  상품규격(무게)
                  <div className='description'>(data type: Decimal(8,3))</div>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>0</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'bundle_avail_yn',
              required: 'O',
              type: 'Number(1)',
              desc: (
                <div>
                  합포장여부
                  <div className='description'>(1: 가능, 0: 불가능)</div>
                </div>
              ),
            },
            {
              title: 'in_unit_cnt',
              required: 'O',
              type: 'Number(10)',
              desc: '입고단위수량',
              indent: 1,
            },
            {
              title: 'in_unit',
              required: 'O',
              type: 'String(10)',
              desc: '입고단위',
              indent: 1,
            },
            {
              title: 'supp_no',
              required: 'O',
              type: 'Number(8)',
              desc: (
                <div>
                  매입처번호
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'supp_name',
              required: 'O',
              type: 'String(50)',
              desc: (
                <div>
                  매입처
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'style_no',
              required: 'O',
              type: 'Number(10)',
              desc: (
                <div>
                  스타일코드
                  <div className='description'>
                    (스타일등록 상품인경우 해당)
                  </div>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'wdate',
              required: 'O',
              type: 'String(19)',
              desc: (
                <div>
                  등록시간
                  <div className='description'>(YYYY-MM-DD HH:mm:ss)</div>
                </div>
              ),
            },
            {
              title: 'mdate',
              required: 'O',
              type: 'String(19)',
              desc: (
                <div>
                  수정시간
                  <div className='description'>(YYYY-MM-DD HH:mm:ss)</div>
                </div>
              ),
            },
            {
              title: 'madein_type',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  원산지 국내외 여부
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>국내</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>해외</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'madein_group',
              required: 'O',
              type: 'String(30)',
              desc: (
                <div>
                  원산지 시/도
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'madein_name',
              required: 'O',
              type: 'String(30)',
              desc: (
                <div>
                  원산지 읍/면
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'madein_etc',
              required: 'O',
              type: 'String(30)',
              desc: (
                <div>
                  기타원산지인경우
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'multi_madein_yn',
              required: 'O',
              type: 'Number(1)',
              desc: (
                <div>
                  복수원산지여부
                  <div className='description'>
                    (1: 복수원산지, 0: 복수원산지 아님)
                  </div>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>0</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'tax_type',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  과세여부
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>과세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>영세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>면세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>비과세</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'brand',
              required: 'O',
              type: 'String(50)',
              desc: '브랜드',
            },
            {
              title: 'model',
              required: 'O',
              type: 'String(50)',
              desc: '모델명',
            },
            {
              title: 'maker',
              required: 'O',
              type: 'String(50)',
              desc: '제조사',
            },
            {
              title: 'maker_eng',
              required: 'O',
              type: 'String(50)',
              desc: '영문 제조사',
            },
            {
              title: 'global_barcode_type',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  UPC/EAN
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>UPC</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>EAN</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'global_barcode',
              required: 'O',
              type: 'String(13)',
              desc: (
                <div>
                  UPC/EAN코드
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'barcode',
              required: 'O',
              type: 'String(50)',
              desc: '바코드',
              indent: 1,
            },
            {
              title: 'hscd',
              required: 'O',
              type: 'String(10)',
              desc: (
                <div>
                  hscd 코드 4~10자리
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'isbn',
              required: 'O',
              type: 'Number(13)',
              desc: (
                <div>
                  isbn 코드 13자리
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'use_age',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  사용연령
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>전체</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>0~3세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>4~6세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>7~12세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>13~15세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>16~19세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>20세이상</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'prod_img',
              required: 'O',
              type: 'String(255)',
              desc: 'SKU상품 이미지',
            },
            {
              title: 'contents',
              required: 'O',
              type: 'String(65535)',
              desc: '상세설명',
            },
            {
              title: 'product_price',
              required: 'O',
              type: 'Number(12)',
              desc: (
                <div>
                  판매가
                  <div className='description'>(data type: Decimal(12,2))</div>
                </div>
              ),
            },
            {
              title: 'cost_price',
              required: 'O',
              type: 'Number(12)',
              desc: (
                <div>
                  원가
                  <div className='description'>(data type: Decimal(12,2))</div>
                </div>
              ),
            },
            {
              title: 'supply_price',
              required: 'O',
              type: 'Number(12)',
              desc: (
                <div>
                  공급가
                  <div className='description'>(data type: Decimal(12,2))</div>
                </div>
              ),
            },
            {
              title: 'options',
              required: 'O',
              type: 'object[]',
              desc: '옵션',
            },
            {
              title: 'attri',
              required: 'O',
              type: 'String(50)',
              desc: '옵션타입',
              indent: 1,
            },
            {
              title: 'attri_type',
              required: 'O',
              type: 'String(30)',
              desc: '옵션명',
              indent: 1,
            },
            {
              title: 'depots',
              required: 'O',
              type: 'object[]',
              desc: '배송처 정보',
            },
            {
              title: 'depot_no',
              required: 'O',
              type: 'Number(11)',
              desc: '배송처 번호',
              indent: 1,
            },
            {
              title: 'depot_name',
              required: 'O',
              type: 'String(45)',
              desc: '배송처명',
              indent: 1,
            },
            {
              title: 'real_stock',
              required: 'O',
              type: 'Number(8)',
              desc: '실재고',
              indent: 1,
            },
            {
              title: 'safe_stock',
              required: 'O',
              type: 'Number(8)',
              desc: '안전재고',
              indent: 1,
            },
            {
              title: 'out_leadtime',
              required: '',
              type: 'Number(8)',
              desc: '출고 리드타임',
              indent: 1,
            },
            {
              title: 'total',
              required: 'O',
              type: 'Number',
              desc: '총 카운트',
            },
          ],
          response_example: {
            results: [
              {
                  sol_no: 1,
                  ori_prod_no: 9999999,
                  prod_no: 9988888,
                  sku_cd: "TEST_SKU_CD",
                  stock_cd: null,
                  prod_name: "TEST",
                  main_depot_no: 99999,
                  made_date: "0000-00-00",
                  expire_date: "0000-00-00",
                  prod_width: 0,
                  prod_height: 0,
                  prod_depth: 0,
                  prod_weight: 0,
                  bundle_avail_yn: 1,
                  in_unit_cnt: null,
                  in_unit: "EA",
                  supp_no: null,
                  supp_name: null,
                  style_no: null,
                  wdate: "2024-02-22 11:54:20",
                  mdate: "2024-02-22 12:03:11",
                  madein_type: null,
                  madein_group: null,
                  madein_name: null,
                  madein_etc: "TEST",
                  multi_madein_yn: 0,
                  tax_type: "과세",
                  brand: "",
                  model: "",
                  maker: "",
                  maker_eng: "",
                  global_barcode_type: null,
                  global_barcode: null,
                  barcode: "",
                  hscd: null,
                  isbn: null,
                  use_age: "",
                  prod_img: "",
                  contents: "TEST DATA",
                  product_price: 0,
                  cost_price: 0,
                  supply_price: 0,
                  options: [
                      {
                          attri: "색상",
                          attri_type: "색상"
                      }
                  ],
                  depots: [
                      {
                          depot_no: 99999,
                          depot_name: "TEST",
                          real_stock: 90,
                          safe_stock: 50,
                          out_leadtime: null
                      }
                  ]
              }
          ],
            total: 1
          },
        },
      ],
    },
    {
      title: 'SKU상품 상세 조회',
      url: '/doc/SKU상품 상세 조회',
      data: [
        {
          version: 'v1.2',
          url: '/stock/:sku_cd/v1.2',
          desc: '사용중인 솔루션에 등록된 SKU상품 정보를 조회합니다.',
          method: 'GET',
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'sku_cd',
              required: 'O',
              type: 'String',
              desc: 'SKU 코드',
            },
          ],
          response: [
            {
              title: 'prod_no',
              required: 'O',
              type: 'Number(10)',
              desc: 'SKU상품 고유번호',
            },
            {
              title: 'ori_prod_no',
              required: 'O',
              type: 'Number(10)',
              desc: (
                <div>
                  원본 SKU상품 고유번호
                  <div className='description'>
                    (조회하는 SKU상품이 사본인 경우 해당)
                  </div>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'sol_no',
              required: 'O',
              type: 'Number(8)',
              desc: '솔루션번호',
            },
            {
              title: 'style_no',
              required: 'O',
              type: 'Number(10)',
              desc: (
                <div>
                  스타일코드
                  <div className='description'>
                    (스타일등록 상품인경우 해당)
                  </div>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'wdate',
              required: 'O',
              type: 'String(19)',
              desc: (
                <div>
                  등록시간
                  <div className='description'>(YYYY-MM-DD HH:mm:ss)</div>
                </div>
              ),
            },
            {
              title: 'mdate',
              required: 'O',
              type: 'String(19)',
              desc: (
                <div>
                  수정시간
                  <div className='description'>(YYYY-MM-DD HH:mm:ss)</div>
                </div>
              ),
            },
            {
              title: 'sku_cd',
              required: 'O',
              type: 'String(40)',
              desc: 'sku코드',
            },
            {
              title: 'prod_name',
              required: 'O',
              type: 'String(200)',
              desc: 'SKU상품명',
            },
            {
              title: 'prod_noti_data',
              required: 'O',
              type: 'object',
              desc: (
                <div>
                  상품정보제공고시
                  <div className='description' style={{ padding: '12px 0' }}>
                    <ul style={{ color: 'gray' }}>
                      <li>
                        상품분류코드에 따라 infoDetail 안에 키 값이 달라질 수
                        있습니다.
                      </li>
                      <li>
                        Default value:
                        <code style={{ fontSize: '15px' }}>{'{}'}</code>
                      </li>
                    </ul>
                  </div>
                </div>
              ),
            },
            {
              title: 'infoCode',
              required: 'O',
              type: 'String',
              desc: '상품분류코드',
              indent: 1,
            },
            {
              title: 'infoName',
              required: 'O',
              type: 'String',
              desc: '상품분류명',
              indent: 1,
            },
            {
              title: 'infoDetail',
              required: 'O',
              type: 'String',
              desc: '상품정보 제공고시 데이터',
              indent: 1,
            },
            {
              title: 'madein_type',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  원산지 국내외 여부
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>국내</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>해외</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'madein_group',
              required: 'O',
              type: 'String(30)',
              desc: (
                <div>
                  원산지 시/도
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'madein_name',
              required: 'O',
              type: 'String(30)',
              desc: (
                <div>
                  원산지 읍/면
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'madein_etc',
              required: 'O',
              type: 'String(30)',
              desc: (
                <div>
                  기타원산지인경우
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'multi_madein_yn',
              required: 'O',
              type: 'Number(1)',
              desc: (
                <div>
                  복수원산지여부
                  <div className='description'>
                    (1: 복수원산지, 0: 복수원산지 아님)
                  </div>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>0</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'tax_type',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  과세여부
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>과세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>영세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>면세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>비과세</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'brand',
              required: 'O',
              type: 'String(50)',
              desc: '브랜드',
            },
            {
              title: 'model',
              required: 'O',
              type: 'String(50)',
              desc: '모델명',
            },
            {
              title: 'maker',
              required: 'O',
              type: 'String(50)',
              desc: '제조사',
            },
            {
              title: 'maker_eng',
              required: 'O',
              type: 'String(50)',
              desc: '영문 제조사',
            },
            {
              title: 'made_date',
              required: 'O',
              type: 'String(10)',
              desc: (
                <div>
                  제조일자
                  <div className='description'>(YYYY-MM-DD)</div>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'expire_date',
              required: 'O',
              type: 'String(10)',
              desc: (
                <div>
                  유효일자
                  <div className='description'>(YYYY-MM-DD)</div>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'bundle_avail_yn',
              required: 'O',
              type: 'Number(1)',
              desc: (
                <div>
                  합포장여부
                  <div className='description'>(1: 가능, 0: 불가능)</div>
                </div>
              ),
            },
            {
              title: 'prod_width',
              required: 'O',
              type: 'Number(8)',
              desc: (
                <div>
                  상품규격(가로)
                  <div className='description'>(data type: Decimal(8,3))</div>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>0</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'prod_height',
              required: 'O',
              type: 'Number(8)',
              desc: (
                <div>
                  상품규격(세로)
                  <div className='description'>(data type: Decimal(8,3))</div>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>0</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'prod_depth',
              required: 'O',
              type: 'Number(8)',
              desc: (
                <div>
                  상품규격(높이)
                  <div className='description'>(data type: Decimal(8,3))</div>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>0</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'prod_weight',
              required: 'O',
              type: 'Number(8)',
              desc: (
                <div>
                  상품규격(무게)
                  <div className='description'>(data type: Decimal(8,3))</div>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>0</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'global_barcode_type',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  UPC/EAN
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>UPC</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>EAN</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'global_barcode',
              required: 'O',
              type: 'String(13)',
              desc: (
                <div>
                  UPC/EAN코드
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'barcode',
              required: 'O',
              type: 'String(50)',
              desc: '바코드',
            },
            {
              title: 'hscd',
              required: 'O',
              type: 'String(10)',
              desc: (
                <div>
                  hscd 코드 4~10자리
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'isbn',
              required: 'O',
              type: 'Number(13)',
              desc: (
                <div>
                  isbn 코드 13자리
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'supp_no',
              required: 'O',
              type: 'Number(8)',
              desc: (
                <div>
                  매입처번호
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'use_age',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  사용연령
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>전체</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>0~3세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>4~6세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>7~12세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>13~15세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>16~19세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>20세이상</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'prod_img',
              required: 'O',
              type: 'String(255)',
              desc: 'SKU상품 이미지',
            },
            {
              title: 'contents',
              required: 'O',
              type: 'String(65535)',
              desc: '상세설명',
            },
            {
              title: 'stock_cd',
              required: 'O',
              type: 'String(100)',
              desc: (
                <div>
                  재고관리코드
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>null</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'product_price',
              required: 'O',
              type: 'Number(12)',
              desc: (
                <div>
                  판매가
                  <div className='description'>(data type: Decimal(12,2))</div>
                </div>
              ),
            },
            {
              title: 'cost_price',
              required: 'O',
              type: 'Number(12)',
              desc: (
                <div>
                  원가
                  <div className='description'>(data type: Decimal(12,2))</div>
                </div>
              ),
            },
            {
              title: 'supply_price',
              required: 'O',
              type: 'Number(12)',
              desc: (
                <div>
                  공급가
                  <div className='description'>(data type: Decimal(12,2))</div>
                </div>
              ),
            },
            {
              title: 'options',
              required: 'O',
              type: 'object[]',
              desc: '옵션',
            },
            {
              title: 'attri',
              required: 'O',
              type: 'String(50)',
              desc: '옵션타입',
              indent: 1,
            },
            {
              title: 'attri_type',
              required: 'O',
              type: 'String(30)',
              desc: '옵션명',
              indent: 1,
            },
            {
              title: 'depots',
              required: 'O',
              type: 'object[]',
              desc: '배송처 정보',
            },
            {
              title: 'depot_no',
              required: 'O',
              type: 'Number(11)',
              desc: '배송처 번호',
              indent: 1,
            },
            {
              title: 'depot_name',
              required: 'O',
              type: 'String(45)',
              desc: '배송처명',
              indent: 1,
            },
            {
              title: 'real_stock',
              required: 'O',
              type: 'Number(8)',
              desc: '실재고',
              indent: 1,
            },
            {
              title: 'safe_stock',
              required: 'O',
              type: 'Number(8)',
              desc: '안전재고',
              indent: 1,
            },
            {
              title: 'out_leadtime',
              required: '',
              type: 'Number(8)',
              desc: '출고 리드타임',
              indent: 1,
            },
          ],
          response_example: {
            prod_no: 345272,
            ori_prod_no: null,
            sol_no: 640,
            style_no: null,
            wdate: '2021-05-20 14:47:09',
            mdate: '2021-06-02 05:01:29',
            sku_cd: 'S61731261611',
            prod_name: '테스트 SKU상품',
            prod_noti_data: {
              infoCode: 'Wear2023',
              infoName: '의류',
              infoDetail: {
                material: '1',
                color: '2',
                size: '3',
                manufacturer: '4',
                made_in: '5',
                caution: '6',
                release: '7',
                warranty: '8',
                customer_service: '9',
              },
            },
            madein_type: '국내',
            madein_group: '강원',
            madein_name: '강릉시',
            madein_etc: '',
            multi_madein_yn: 0,
            tax_type: '과세',
            brand: '브랜드',
            model: '모델명',
            maker: '제조사',
            maker_eng: 'english maker',
            made_date: '2021-01-01',
            expire_date: '2025-03-01',
            bundle_avail_yn: 1,
            prod_width: 10,
            prod_height: 11,
            prod_depth: 12,
            prod_weight: 3,
            global_barcode_type: 'UPC',
            global_barcode: '9999999',
            barcode: 'barcode',
            hscd: '6201201000',
            isbn: 123456789012,
            supp_no: 2294,
            use_age: '20세이상',
            prod_img:
              'https://s3-ap-northeast-2.amazonaws.com/gmp01/640/prod/S61731261611/e7.jpg',
            contents:
              '<p><span style=\'font-size: 20px; color: red;\'>※ 실제 판매되는 상품이 아닙니다.<br>구매하셔도 배송 되지 않습니다. 구매 시, 별도 안내 없이 환불 됩니다.</span></p><div><img alt="" src="http://playauto.playimage.co.kr/playauto/page.jpg" /><br /></div>',
            stock_cd: 'stock_manage_code',
            product_price: 251000,
            cost_price: 240000,
            supply_price: 248000,
            options: [
              {
                attri: '블루',
                attri_type: '색상',
              },
            ],
            depots: [
              {
                depot_no: 775,
                depot_name: '테스트 배송처',
                real_stock: 100,
                safe_stock: 10,
                out_leadtime: null
              },
              {
                depot_no: 4305,
                depot_name: '테스트 배송처_copy1',
                real_stock: 220,
                safe_stock: 15,
                out_leadtime: null
              },
            ],
          },
        },
      ],
    },
    {
      title: 'SKU상품 등록',
      url: '/doc/SKU상품 등록',
      data: [
        {
          version: 'v1.2',
          url: '/stock/add/v1.2',
          desc: (
            <ul className='style'>
              <li>SKU상품 정보를 등록합니다.</li>
              <li>
                속성없이 등록을 원하시는 경우 opt 항목의 opt1_type에 "없음"으로
                입력해주십시오.
              </li>
              <li>opt는 필수 입력 항목입니다.</li>
              <li>
                두 건 이상의 opt 정보를 입력하시는 경우 스타일 상품으로 등록이
                됩니다.
              </li>
            </ul>
          ),
          method: 'POST',
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'prod_name',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  SKU상품명
                  <div className='description'>
                    상품명은 한글, 영문, 숫자 최대 100자 까지만
                    등록가능합니다.
                    <br />
                    특수문자 <strong><code>|</code></strong> , <strong><code>#</code></strong> 및 지원하지 않는 이모티콘은 사용할 수 없습니다.
                  </div>
                </div>
              ),
            },
            {
              title: 'madein',
              required: '',
              type: 'Object',
              desc: '원산지',
            },
            {
              title: 'madein_no',
              required: 'O',
              type: 'Number',
              desc: (
                <div>
                  원산지번호
                  <div className='description'>
                    (원산지 조회 api 호출하여 확인)
                  </div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'madein_etc',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  기타원산지
                  <div className='description'>
                    (등록하려는 원산지가 origins에서 조회되지않을 때 madein_no를
                    비우고 madein_etc에 값을 넣어줍니다.)
                  </div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'multi_yn',
              required: 'O',
              type: 'Boolean',
              desc: (
                <div>
                  복수원산지여부
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>false</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'tax_type',
              required: '',
              type: 'String',
              desc: (
                <div>
                  과세여부
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>과세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>면세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>영세</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'brand',
              required: '',
              type: 'String',
              desc: '브랜드',
            },
            {
              title: 'maker',
              required: '',
              type: 'String',
              desc: '제조사',
            },
            {
              title: 'maker_eng',
              required: '',
              type: 'String',
              desc: '영문 제조사',
            },
            {
              title: 'made_date',
              required: '',
              type: 'String',
              desc: (
                <div>
                  제조일자
                  <div className='description'>
                    (YYYY-MM-DD의 형식으로 입력해주십시오.)
                  </div>
                </div>
              ),
            },
            {
              title: 'expire_date',
              required: '',
              type: 'String',
              desc: (
                <div>
                  유효일자
                  <div className='description'>
                    (YYYY-MM-DD의 형식으로 입력해주십시오.)
                  </div>
                </div>
              ),
            },
            {
              title: 'cost_price',
              required: '',
              type: 'Number',
              desc: '원가',
            },
            {
              title: 'supply_price',
              required: '',
              type: 'Number',
              desc: '공급가',
            },
            {
              title: 'hscd',
              required: '',
              type: 'String',
              desc: 'HS코드 (4~10자리)',
            },
            {
              title: 'isbn',
              required: '',
              type: 'Number',
              desc: 'ISBN 코드 (13자리 숫자)',
            },
            {
              title: 'supp_no',
              required: '',
              type: 'Number',
              desc: (
                <div>
                  매입처코드
                  <div className='description'>(매입처조회 api 이용)</div>
                </div>
              ),
            },
            {
              title: 'prod_width',
              required: '',
              type: 'Number',
              desc: '규격 - 가로 (cm)',
            },
            {
              title: 'prod_height',
              required: '',
              type: 'Number',
              desc: '규격 - 세로 (cm)',
            },
            {
              title: 'prod_depth',
              required: '',
              type: 'Number',
              desc: '규격 - 높이 (cm)',
            },
            {
              title: 'prod_weight',
              required: '',
              type: 'Number',
              desc: '규격 - 무게 (kg)',
            },
            {
              title: 'use_age',
              required: '',
              type: 'String',
              desc: (
                <div>
                  사용연령
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>전체</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>전체</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>0~3세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>4~6세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>7~12세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>13~15세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>16~19세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>20세이상</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'contents',
              required: '',
              type: 'String',
              desc: '상세설명',
            },
            {
              title: 'opt',
              required: 'O',
              type: 'Object[]',
              desc: '속성정보',
            },
            {
              title: 'sku_cd',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  SKU코드
                  <ul className='style' style={{ color: 'gray' }}>
                    <li>
                      SKU 코드는 영문/숫자/특수문자 ( ) - _ = + , . / 만 입력이
                      가능합니다.
                    </li>
                    <li>
                      SKU상품코드 자동생성을 원하시는경우 'AUTO' 로 하십시오.
                    </li>
                  </ul>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'barcode',
              required: '',
              type: 'String',
              desc: (
                <div>
                  바코드
                  <div className='description'>
                    (영문, 숫자, 띄어쓰기와 특수문자 ( ) - _ = + . / , 만 입력이 가능합니다.)
                  </div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'model',
              required: '',
              type: 'String',
              desc: '모델명',
              indent: 1,
            },
            {
              title: 'product_price',
              required: userInfo.aff_no === 1208 ? 'O' : '',
              type: 'Number',
              desc: '판매가',
              indent: 1,
            },
            {
              title: 'main_depot_no',
              required: '',
              type: 'Number',
              desc: (
                <div>
                  sku상품의 대표배송처 코드
                  <div className='description'>
                    (미입력시 입력되는 배송처 정보중 첫번재 값으로 등록)
                  </div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'depots',
              required: 'O',
              type: 'Object[]',
              desc: '배송처 및 재고정보',
              indent: 1,
            },
            {
              title: 'depot_no',
              required: 'O',
              type: 'Number',
              desc: (
                <div>
                  배송처코드
                  <div className='description'>(배송처조회 api 이용)</div>
                </div>
              ),
              indent: 2,
            },
            {
              title: 'real_stock',
              required: 'O',
              type: 'Number',
              desc: '실재고',
              indent: 2,
            },
            {
              title: 'safe_stock',
              required: 'O',
              type: 'Number',
              desc: (
                <div>
                  안전재고
                  <div className='description'>
                    (안전재고는 실재고를 초과할 수 없습니다.)
                  </div>
                </div>
              ),
              indent: 2,
            },
            {
              title: 'out_leadtime',
              required: '',
              type: 'Number',
              desc: '출고 리드타임',
              indent: 2,
            },
            {
              title: 'img_url',
              required: '',
              type: 'String',
              desc: '이미지',
              indent: 1,
            },
            {
              title: 'opt1_type',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  옵션구분
                  <div className='description'>
                    (옵션이 없는 SKU상품인경우 "없음"으로 입력)
                  </div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'opt1',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  옵션값
                  <div className='description'>(ex{'>'}빨강, 파랑....)</div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'opt2_type',
              required: '',
              type: 'String',
              desc: (
                <div>
                  두 번째 옵션이 있는경우 두 번째 옵션구분
                  <div className='description'>(ex{'>'}사이즈)</div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'opt2',
              required: '',
              type: 'String',
              desc: '두번째 옵션이 있는경우 두번째 옵션 값',
              indent: 1,
            },
            {
              title: 'prod_info',
              required: '',
              type: 'Object',
              desc: (
                <div>
                  품목정보고시
                  <br />
                  <div className='description'>
                    <ul style={{ color: 'gray' }}>
                      <li>아래의 등록가이드를 참고해주세요.</li>
                      <li>
                        <a
                          href='https://gmp-master.s3.ap-northeast-2.amazonaws.com/download/Sample_prodInfo_guide_OPENAPI.xlsx'
                          style={{ color: 'blue' }}
                        >
                          상품 품목정보고시 가이드 개정판
                        </a>
                      </li>
                    </ul>
                  </div>
                </div>
              ),
            },
            {
              title: 'infoCode',
              required: 'O',
              type: 'String',
              desc: '상품분류코드',
              indent: 1,
            },
            {
              title: 'infoDetail',
              required: 'O',
              type: 'Object',
              desc: (
                <div>
                  상품 정보 제공고시 데이터
                  <ul style={{ color: 'gray' }}>
                    <li>
                      품목 정보고시 가이드에 기재된 각 항목에 따른 key와 value를
                      입력합니다.
                    </li>
                  </ul>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'is_desc_referred',
              type: 'boolean',
              desc: (
                <div>
                  상품 정보 제공고시 데이터 일괄 [상세설명참조] 적용
                  <ul style={{ color: 'gray' }}>
                    <li>
                      해당 값을 <code>true</code> 로 설정 시 입력한 값과 상관 없이 일괄 <code>[상세설명참조]</code>로 적용됩니다.
                    </li>
                  </ul>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'global_barcode_type',
              required: '',
              type: 'String',
              desc: (
                <div>
                  UPC/EAN 타입
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>UPC</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>EAN</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'global_barcode',
              required: '',
              type: 'Number',
              desc: 'UPC/EAN 코드',
            },
            {
              title: 'barcode',
              required: '',
              type: 'String',
              desc: '바코드',
            },
            {
              title: 'stock_cd',
              required: '',
              type: 'String',
              desc: '재고관리코드',
            },
          ],
          body_example: {
            prod_name: '테스트 SKU상품',
            madein: {
              madein_no: '2',
              madein_etc: '',
              multi_yn: false,
            },
            tax_type: '영세',
            brand: '브랜드',
            maker: '제조사',
            maker_eng: 'english maker',
            made_date: '',
            expire_date: '2020-06-01',
            cost_price: '10000',
            supply_price: '12000',
            global_barcode: '',
            hscd: '6201201000',
            isbn: '1313131313131',
            use_age: '전체',
            contents: '상세설명',
            prod_width: '10',
            prod_height: '20',
            prod_depth: '30',
            prod_weight: '40',
            supp_no: '1933',
            main_depot_no: '746',
            opt: [
              {
                sku_cd: 'AUTO',
                barcode: '',
                model: '',
                product_price: 15000,
                depots: [
                  {
                    depot_no: 746,
                    real_stock: 999,
                    safe_stock: 10
                  },
                ],
                opt1_type: '색상',
                opt2_type: '사이즈',
                opt1: '빨강',
                opt2: '큼',
                img_url: 'http://sample.playauto.io/sample.png',
              },
              {
                sku_cd: 'S109CFEF4160',
                barcode: '',
                model: '',
                product_price: 15000,
                depots: [
                  {
                    depot_no: 800,
                    real_stock: 88,
                    safe_stock: 5
                  },
                ],
                opt1_type: '색상',
                opt2_type: '사이즈',
                opt1: '빨강',
                opt2: '작음',
                img_url: 'http://sample.playauto.io/sample.png',
              },
            ],
            prod_info: {
              infoCode: 'Wear2023',
              infoDetail: {
                material: '1',
                color: '2',
                size: '3',
                manufacturer: '4',
                made_in: '5',
                caution: '6',
                release: '7',
                warranty: '8',
                customer_service: '9',
              },
            },
          },
          response: [
            {
              title: 'success',
              required: 'O',
              type: 'Number',
              desc: '등록 성공 갯수',
            },
            {
              title: 'fail',
              required: 'O',
              type: 'Number',
              desc: '등록 실패 갯수',
            },
            {
              title: 'results',
              required: 'O',
              type: 'Object[]',
              desc: '결과상세',
            },
            {
              title: 'prod_no',
              required: 'O',
              type: 'Number',
              desc: 'SKU상품 고유 키',
              indent: 1,
            },
            {
              title: 'sku_cd',
              required: 'O',
              type: 'String',
              desc: 'sku 코드',
              indent: 1,
            },
            {
              title: 'messages',
              required: 'O',
              type: 'String[]',
              desc: '등록이 실패된경우 에러 메세지',
              indent: 1,
            },
          ],
          response_example: {
            success: 1,
            fail: 1,
            results: [
              {
                prod_no: 5126403,
                sku_cd: 'S220DCBA83A3',
                message: '',
              },
              {
                prod_no: 0,
                sku_cd: 'S109CFEF4160',
                error_code: 'e3008',
                messages: [
                  '이미 등록된 sku_cd 입니다.'
                ],
              },
            ],
          },
        },
      ],
    },
    {
      title: 'SKU상품 수정',
      url: '/doc/SKU상품 수정',
      data: [
        {
          version: 'v1.2',
          url: '/stock/edit/v1.2',
          method: 'PUT',
          desc: (
            <ul className='style'>
              <li>SKU상품 정보를 수정합니다.</li>
            </ul>
          ),
          header: default_header,
          header_example: default_header_example,
          body: [
            {
              title: 'sku_cd',
              required: 'O',
              type: 'String',
              desc: 'sku코드',
            },
            {
              title: 'prod_name',
              required: '',
              type: 'String',
              desc: (
                <div>
                  SKU상품명
                  <div className='description'>
                    상품명은 한글, 영문, 숫자 최대 100자 까지만
                    등록가능합니다.
                    <br />
                    특수문자 <strong><code>|</code></strong> , <strong><code>#</code></strong> 및 지원하지 않는 이모티콘은 사용할 수 없습니다.
                  </div>
                </div>
              ),
            },
            {
              title: 'madein',
              required: '',
              type: 'Object',
              desc: '원산지',
            },
            {
              title: 'madein_no',
              required: 'O',
              type: 'Number',
              desc: (
                <div>
                  원산지 번호
                  <div className='description'>
                    (원산지 조회 api 호출하여 확인)
                  </div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'madein_etc',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  기타원산지
                  <div className='description'>
                    (등록하려는 원산지가 origins 에서 조회되지않을때 madein_no
                    를 비우고 madein_etc 에 값을 넣어줍니다.)
                  </div>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'multi_yn',
              required: 'O',
              type: 'Boolean',
              desc: (
                <div>
                  복수원산지여부
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>false</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'tax_type',
              required: '',
              type: 'String',
              desc: (
                <div>
                  과세여부
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>과세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>면세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>영세</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'brand',
              required: '',
              type: 'String',
              desc: '브랜드',
            },
            {
              title: 'model',
              required: '',
              type: 'String',
              desc: '모델명',
            },
            {
              title: 'maker',
              required: '',
              type: 'String',
              desc: '제조사',
            },
            {
              title: 'maker_eng',
              required: '',
              type: 'String',
              desc: '영문 제조사',
            },
            {
              title: 'made_date',
              required: '',
              type: 'String',
              desc: (
                <div>
                  제조일자
                  <div className='description'>
                    (YYYY-MM-DD의 형식으로 입력해주십시오.)
                  </div>
                </div>
              ),
            },
            {
              title: 'expire_date',
              required: '',
              type: 'String',
              desc: (
                <div>
                  유효일자
                  <div className='description'>
                    (YYYY-MM-DD의 형식으로 입력해주십시오.)
                  </div>
                </div>
              ),
            },
            {
              title: 'supp_no',
              required: '',
              type: 'Number',
              desc: (
                <div>
                  매입처코드
                  <div className='description'>(매입처조회 api 이용)</div>
                </div>
              ),
            },
            {
              title: 'prod_width',
              required: '',
              type: 'Number',
              desc: '규격 - 가로 (cm)',
            },
            {
              title: 'prod_height',
              required: '',
              type: 'Number',
              desc: '규격 - 세로 (cm)',
            },
            {
              title: 'prod_depth',
              required: '',
              type: 'Number',
              desc: '규격 - 높이 (cm)',
            },
            {
              title: 'prod_weight',
              required: '',
              type: 'Number',
              desc: '규격 - 무게 (kg)',
            },
            {
              title: 'use_age',
              required: '',
              type: 'String',
              desc: (
                <div>
                  사용연령
                  <div className='description' style={{ padding: '12px 0' }}>
                    Default value
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>전체</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>전체</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>0~3세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>4~6세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>7~12세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>13~15세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>16~19세</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>20세이상</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'contents',
              required: '',
              type: 'String',
              desc: '상세설명',
            },
            {
              title: 'opt1_type',
              required: '',
              type: 'String',
              desc: '첫번째 옵션구분',
            },
            {
              title: 'opt1',
              required: '',
              type: 'String',
              desc: '첫번째 옵션값',
            },
            {
              title: 'opt2_type',
              required: '',
              type: 'String',
              desc: '두번째 옵션구분',
            },
            {
              title: 'opt2',
              required: '',
              type: 'String',
              desc: '두번째 옵션값',
            },
            {
              title: 'opt3_type',
              required: '',
              type: 'String',
              desc: '세번째 옵션구분',
            },
            {
              title: 'opt3',
              required: '',
              type: 'String',
              desc: '세번째 옵션값',
            },
            {
              title: 'depots',
              required: '',
              type: 'Object[]',
              desc: '배송처 및 재고정보',
            },
            {
              title: 'depot_no',
              required: 'O',
              type: 'Number',
              desc: '배송처번호',
              indent: 1,
            },
            {
              title: 'real_stock',
              required: 'O',
              type: 'Number',
              desc: (
                <div>
                  실재고
                  <ul style={{ color: 'gray' }}>
                    <li>
                      실재고 수량은 출고예정수량(실재고-판매가능재고)보다 커야 합니다.
                    </li>
                  </ul>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'safe_stock',
              required: '',
              type: 'Number',
              desc: '안전재고',
              indent: 1,
            },
            {
              title: 'prod_info',
              required: '',
              type: 'Object',
              desc: (
                <div>
                  품목정보고시
                  <br />
                  <br />
                  <div className='description'>
                    아래의 등록가이드를 참고해주세요.
                  </div>
                  <a
                    style={{ color: 'blue' }}
                    href='https://gmp-master.s3.ap-northeast-2.amazonaws.com/download/Sample_prodInfo_guide_OPENAPI.xlsx'
                  >
                    상품 품목정보고시 가이드 개정판
                  </a>
                </div>
              ),
            },
            {
              title: 'infoCode',
              required: 'O',
              type: 'String',
              desc: '상품분류코드',
              indent: 1,
            },
            {
              title: 'infoDetail',
              required: 'O',
              type: 'Object',
              desc: (
                <div>
                  상품 정보 제공고시 데이터
                  <ul style={{ color: 'gray' }}>
                    <li>
                      품목 정보고시 가이드에 기재된 각 항목에 따른 key와 value를
                      입력합니다.
                    </li>
                  </ul>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'is_desc_referred',
              type: 'boolean',
              desc: (
                <div>
                  상품 정보 제공고시 데이터 일괄 [상세설명참조] 적용
                  <ul style={{ color: 'gray' }}>
                    <li>
                      해당 값을 <code>true</code> 로 설정 시 입력한 값과 상관 없이 일괄 <code>[상세설명참조]</code>로 적용됩니다.
                    </li>
                  </ul>
                </div>
              ),
              indent: 1,
            },
            {
              title: 'product_price',
              required: '',
              type: 'Number',
              desc: '판매가',
            },
            {
              title: 'supply_price',
              required: '',
              type: 'Number',
              desc: '공급가',
            },
            {
              title: 'cost_price',
              required: '',
              type: 'Number',
              desc: '원가',
            },
            {
              title: 'global_barcode_type',
              required: '',
              type: 'String',
              desc: (
                <div>
                  UPC/EAN
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>UPC</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>EAN</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'global_barcode',
              required: '',
              type: 'Number',
              desc: 'UPC/EAN 코드',
            },
            {
              title: 'hscd',
              required: '',
              type: 'String',
              desc: 'HS코드',
            },
            {
              title: 'isbn',
              required: '',
              type: 'Number',
              desc: 'ISBN 코드 (13자리 숫자)',
            },
            {
              title: 'barcode',
              required: '',
              type: 'String',
              desc: '바코드',
            },
            {
              title: 'stock_cd',
              required: '',
              type: 'String',
              desc: '재고관리코드',
            },
          ],
          body_example: {
            sku_cd: 'aowlkj123',
            prod_name: '테스트 SKU상품',
            madein: {
              madein_no: '2',
              madein_etc: '',
              multi_yn: false,
            },
            tax_type: '영세',
            brand: '브랜드',
            maker: '제조사',
            cost_price: '10000',
            delivery_vendor: '746',
            contents: '상세설명',
            opt1_type: '색상',
            opt1: '빨강',
            depots: [
              {
                depot_no: 994,
                real_stock: 99,
                safe_stock: 5,
              },
              {
                depot_no: 1025,
                real_stock: 100,
                safe_stock: 35,
              },
            ],
            prod_info: {
              infoCode: 'Wear2023',
              infoDetail: {
                material: '1',
                color: '2',
                size: '3',
                manufacturer: '4',
                made_in: '5',
                caution: '6',
                release: '7',
                warranty: '8',
                customer_service: '9',
              },
            },
          },
          response: [
            {
              title: 'sku_cd',
              required: 'O',
              type: 'Number',
              desc: 'sku 코드',
            },
            {
              title: 'result',
              required: 'O',
              type: 'String',
              desc: (
                <div>
                  성공, 실패 여부
                  <div className='description' style={{ padding: '12px 0' }}>
                    Allowed values
                  </div>
                  <table>
                    <thead>
                      <tr>
                        <th>Value</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>
                          <strong>
                            <code>성공</code>
                          </strong>
                        </td>
                      </tr>
                      <tr>
                        <td>
                          <strong>
                            <code>실패</code>
                          </strong>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              ),
            },
            {
              title: 'error_code',
              required: 'O',
              type: 'String',
              desc: '에러코드',
            },
            {
              title: 'message',
              required: 'O',
              type: 'String',
              desc: '에러메세지',
            },
          ],
          response_example: {
            sku_cd: 'S55512193',
            result: '성공',
            message: '',
          },
          error_example: {
            "sku_cd": "",
            "result": "실패",
            "error_code": "e3020",
            "messages": [
              "수정할 정보가 없습니다."
            ]
          }
        },
      ],
    },
  ];
};

export default getV12APIs;
